if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.priceWrapper = this.querySelector('.sticky-add-to-cart__price');
        this.sectionId = this.dataset.sectionId;
        this.priceSourceId = this.dataset.priceSourceId;
      }

      connectedCallback() {
        this.submitButton = document.getElementById(this.dataset.submitButtonId);
        if (!this.submitButton) return;

        this.button.addEventListener('click', this.handleClick.bind(this));

        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.mediaQuery.addEventListener('change', this.updateObserver.bind(this));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }

        this.updateObserver();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mediaQuery?.removeEventListener('change', this.updateObserver);
        this.variantChangeUnsubscriber?.();
      }

      updateObserver() {
        this.intersectionObserver?.disconnect();
        if (!this.mediaQuery.matches) {
          this.setAttribute('hidden', '');
          return;
        }

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const isSubmitButtonVisible = entries[0].isIntersecting;
            this.toggleAttribute('hidden', isSubmitButtonVisible);
          },
          { threshold: 0 }
        );
        this.intersectionObserver.observe(this.submitButton);
      }

      handleClick() {
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.submitButton.disabled) return;

        const quantitySelector = this.dataset.quantitySelectorId
          ? document.getElementById(this.dataset.quantitySelectorId)
          : null;

        if (quantitySelector) {
          quantitySelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.submitButton.click();
      }

      handleVariantChange({ data: { sectionId, html, variant } }) {
        if (sectionId !== this.sectionId) return;

        const sourcePrice = html.getElementById?.(this.priceSourceId) ?? html.querySelector(`#${this.priceSourceId}`);
        if (sourcePrice && this.priceWrapper) {
          this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        const isUnavailable = !variant || variant.available === false;
        this.button.disabled = isUnavailable;
        const label = this.button.querySelector('span');
        if (label && window.variantStrings) {
          label.textContent = !variant
            ? window.variantStrings.unavailable
            : variant.available === false
            ? window.variantStrings.soldOut
            : window.variantStrings.addToCart;
        }
      }
    }
  );
}
